// extracted by mini-css-extract-plugin
module.exports = {"row-divider":"AllianzWithdrawalConfirm_row-divider_2IXXR"};